import Axios from 'axios'
import { Component } from 'preact'

class LegacyLoginModals extends Component {
  ref: HTMLDivElement | null = null

  // This crap is here to load the legacy modals used by the login/registration system
  async componentDidMount() {
    if (!this.ref) return
    const response = await Axios.get('/widget/legacyLoginModals')
    this.ref.innerHTML = response.data

    Array.from(this.ref.querySelectorAll('script')).forEach((oldScript) => {
      const newScript = document.createElement('script')
      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value)
      )
      newScript.appendChild(document.createTextNode(oldScript.innerHTML))
      oldScript.parentNode?.replaceChild(newScript, oldScript)
    })
  }

  render() {
    return (
      <div
        ref={(el) => {
          this.ref = el
        }}
      />
    )
  }
}

export default LegacyLoginModals
